// DashboardPageHeader.tsx — Sprint 14. Sticky breadcrumb + title row
// + Quick Insights / Export Report buttons (overview tab only) +
// the collection-rate Tag.
import React from 'react';
import { Breadcrumb, Button, Col, Row, Space, Tag, Typography } from 'antd';
import {
  BarChartOutlined, FilePdfOutlined, HomeOutlined, RightOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

export interface DashboardPageHeaderProps {
  pageTitle:           string;
  isOverview:          boolean;
  currentCondoName?:   string;
  userDisplayName?:    string;
  feeCollectionRate:   number;
  onExportReport:      () => void;
  onQuickInsights:     () => void;
}

export const DashboardPageHeader: React.FC<DashboardPageHeaderProps> = ({
  pageTitle, isOverview, currentCondoName, userDisplayName,
  feeCollectionRate, onExportReport, onQuickInsights,
}) => (
  <div style={{
    padding: '24px 0 16px',
    background: '#f8fafc',
    position: 'sticky', top: 0, zIndex: 99,
    borderBottom: '1px solid #e2e8f0',
    marginBottom: 24,
  }}>
    <Row align="middle" justify="space-between">
      <Col>
        <Space direction="vertical" size={4}>
          <Breadcrumb
            separator={<RightOutlined style={{ fontSize: 12, color: '#a0aec0' }} />}
            style={{ fontSize: 14 }}
          >
            <Breadcrumb.Item><HomeOutlined style={{ color: '#718096' }} /></Breadcrumb.Item>
            <Breadcrumb.Item>
              <Text style={{ color: '#4a5568' }}>{currentCondoName || 'Dashboard'}</Text>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Text strong style={{ color: '#2d3748' }}>{pageTitle}</Text>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Title level={3} style={{ margin: 0, color: '#1a202c' }}>{pageTitle}</Title>
          {isOverview && (
            <Text style={{ color: '#718096', fontSize: 14 }}>
              Welcome back, {userDisplayName || 'User'}. Here's your property overview.
            </Text>
          )}
        </Space>
      </Col>
      <Col>
        <Space size="middle">
          {isOverview && (
            <>
              <Button icon={<FilePdfOutlined />} style={{ borderRadius: 8 }} onClick={onExportReport}>
                Export Report
              </Button>
              <Button type="primary" icon={<BarChartOutlined />} style={{ borderRadius: 8 }} onClick={onQuickInsights}>
                Quick Insights
              </Button>
            </>
          )}
          {/* Sprint 35 — finding G11. The Tag used to render
              "Collection: 7%" on every header, including Oak Ridge
              (0 fees, no meaningful rate) and the admin-no-condo
              state (no condo to collect from). Hide when there's no
              condo selected OR the rate is meaningless (0% with no
              fees, which is the empty-state case). */}
          {currentCondoName && feeCollectionRate > 0 && (
            <Tag
              color={feeCollectionRate > 90 ? 'success' : feeCollectionRate > 70 ? 'warning' : 'error'}
              style={{ borderRadius: 6, fontWeight: 600, padding: '4px 12px' }}
            >
              Collection: {feeCollectionRate}%
            </Tag>
          )}
        </Space>
      </Col>
    </Row>
  </div>
);
